<mat-form-field
  [formGroup]="formulario"
  appearance="fill"
  fxFlex>
  <mat-label>{{label}}</mat-label>
  <input
    type="text"
    matInput
    [formControlName]="nameControl"
    [matAutocomplete]="auto">
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn">
    <mat-option
      *ngFor="let option of filteredSystemFieldOptions | async; let i = index"
      [value]="option">
      {{option.label}}
    </mat-option>
  </mat-autocomplete>
  <mat-hint>{{hint}}</mat-hint>
</mat-form-field>
<mat-icon
  *ngIf="matTooltipText !== ''"
  [style.margin-left.px]="20"
  class="ps_formBuilder_tooltipIcon"
  [matTooltip]="matTooltipText"
  matTooltipPosition="after"
  matTooltipClass="ps-tooltip-preLined-content"
  svgIcon="help">
</mat-icon>
